/**
 * botWaveFollow — allied minion wave follow for ARAM bots (FID-BOT-10 / FID-BOT-12).
 *
 * Pure JS — no Three.js, no DOM.
 */

function entityZ(e) {
  if (!e) return 0;
  if (e.z !== undefined) return e.z;
  return e.y !== undefined ? e.y : 0;
}

export function isMinionEntity(entity) {
  if (!entity) return false;
  if (entity.minionType) return true;
  return String(entity.type || '').startsWith('minion');
}

function distance2d(a, b) {
  return Math.hypot(b.x - a.x, entityZ(b) - entityZ(a));
}

export function nearestAlliedMinion(bot, allEntities = []) {
  if (!bot) return null;
  let best = null;
  let bestDist = Infinity;
  for (const entity of allEntities) {
    if (!entity || entity.isDead) continue;
    if (entity.team !== bot.team) continue;
    if (!isMinionEntity(entity)) continue;
    const dist = distance2d(bot, entity);
    if (dist < bestDist) {
      bestDist = dist;
      best = entity;
    }
  }
  return best;
}

function isChaosTeam(team) {
  return team === 'red' || team === 'chaos';
}

/** Allied minion furthest toward the enemy pad (ARAM +Z for red, −Z for blue). */
export function alliedWaveFrontMinion(bot, allEntities = []) {
  if (!bot) return null;
  const chaos = isChaosTeam(bot.team);
  let best = null;
  let bestZ = chaos ? -Infinity : Infinity;
  for (const entity of allEntities) {
    if (!entity || entity.isDead) continue;
    if (entity.team !== bot.team) continue;
    if (!isMinionEntity(entity)) continue;
    const z = entityZ(entity);
    const better = chaos ? z > bestZ : z < bestZ;
    if (better) {
      bestZ = z;
      best = entity;
    }
  }
  return best;
}

export function alliedWaveFollowTarget(bot, allEntities = []) {
  const minion = alliedWaveFrontMinion(bot, allEntities);
  if (!minion) return null;
  return { x: minion.x, z: entityZ(minion) };
}
